import { render, staticRenderFns } from "./edit-task-category.vue?vue&type=template&id=6d3dadf6&"
import script from "./edit-task-category.vue?vue&type=script&lang=js&"
export * from "./edit-task-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d3dadf6')) {
      api.createRecord('6d3dadf6', component.options)
    } else {
      api.reload('6d3dadf6', component.options)
    }
    module.hot.accept("./edit-task-category.vue?vue&type=template&id=6d3dadf6&", function () {
      api.rerender('6d3dadf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/task/edit-task-category.vue"
export default component.exports